import { handleActions } from "redux-actions";
import { MERCHANT } from "constants/action-types";
import { IQuery, IMutate, RequestStatus } from "constants/crud";
import { GetMerchantSharedSettingsRequestAction, GetMerchantSharedSettingsCompleteAction } from "actions/merchant";
import { IMerchantSharedSettings } from "constants/merchant";

export interface IStateMerchantDefaultSharedSettings
    extends IQuery<IMerchantSharedSettings>,
        IMutate<IMerchantSharedSettings> {}

const initialState: IStateMerchantDefaultSharedSettings = {
    queryError: undefined,
    queryStatus: RequestStatus.Active,
    mutateStatus: RequestStatus.Idle,
    mutateError: undefined,
    result: undefined,
};

export const merchantDefaultSharedSettings = handleActions<IStateMerchantDefaultSharedSettings, any>(
    {
        [MERCHANT.SHARED_SETTINGS.GET.REQUEST]: (
            state: IStateMerchantDefaultSharedSettings,
            _action: GetMerchantSharedSettingsRequestAction
        ): IStateMerchantDefaultSharedSettings => {
            return {
                ...state,
                ...initialState,
            };
        },
        [MERCHANT.SHARED_SETTINGS.GET.COMPLETE]: (
            state: IStateMerchantDefaultSharedSettings,
            action: GetMerchantSharedSettingsCompleteAction
        ): IStateMerchantDefaultSharedSettings => {
            return {
                ...state,
                queryStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                queryError: action.payload instanceof Error ? action.payload : undefined,
                result: action.payload instanceof Error ? undefined : action.payload,
            };
        },
    } as any,
    initialState
);
